import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import {
  InitialResponseTabs,
  InitialResponseTabsType,
} from './InitialResponseTabs';

type PlanningStepperProps = {
  currentPhase: InitialResponseTabsType;
  updatePhase: (phase: InitialResponseTabsType) => void;
};

const InitialResponseStepper: React.FC<PlanningStepperProps> = ({
  currentPhase,
  updatePhase,
}) => {
  return (
    <div className="initial-response-stepper mt-3" data-tour="incident-ir-stepper">
      <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap">
        {InitialResponseTabs.map((phase, index) => {
          return (
            <StylishNewButton
              key={index}
              className={
                'button--secondary tab' +
                (phase === currentPhase ? ' active' : '')
              }
              onClick={() => updatePhase(phase)}
            >
              {phase}
            </StylishNewButton>
          );
        })}
      </div>
    </div>
  );
};

export default InitialResponseStepper;
